import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { ViUIService } from '../../../projects/ui';
import { TutorialsStore, TutorialType } from '../../@store';
import { CommonStandaloneModule } from '../../shared/common-standalone.module';
import { HideForRsaUserDirective } from '../../shared/directives';
import { ShepherdCardComponent } from '../../shepherd/components/shepherd-card/shepherd-card.component';
import { SHEPHERD_CARD_TYPES } from '../../shepherd/model';

@Component({
  selector: 'app-tutorials-modal',
  templateUrl: './tutorials-modal.component.html',
  styleUrls: ['./tutorials-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    forwardRef(() => CommonStandaloneModule),
    ShepherdCardComponent,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    forwardRef(() => HideForRsaUserDirective),
  ],
})
export class TutorialsModalComponent {
  readonly smallScreenSizeBreakPoint = 576;

  SHEPHERD_CARD_TYPES = SHEPHERD_CARD_TYPES;
  TutorialType = TutorialType;

  constructor(
    private dialogRef: MatDialogRef<TutorialsModalComponent>,
    private router: Router,
    private tutorialsStore: TutorialsStore,
    public viUIService: ViUIService
  ) {}

  onCancel(): void {
    this.dialogRef.close();
  }

  navigateToTutorial(tutorialType: TutorialType): void {
    this.tutorialsStore.resetTutorial(tutorialType);

    switch (tutorialType) {
      case TutorialType.KanbanBoard: {
        this.viUIService.sidenav$.next();
        this.router.navigate(['/installations/board']);
        break;
      }
      case TutorialType.KanbanInstallationList: {
        this.viUIService.sidenav$.next();
        this.router.navigate(['/installations']);
        break;
      }
      case TutorialType.LandingPage: {
        if (window.innerWidth < this.smallScreenSizeBreakPoint) {
          this.viUIService.sidenav$.next();
        }
        this.router.navigate(['/dashboard']);
        break;
      }
      default: {
        break;
      }
    }

    this.dialogRef.close();
  }
}
